import type { MediaItem } from "@/mocks/media";
import { formatViews } from "@/utils/format";
import { typeLabel } from "@/utils/format";
import { Link } from "react-router-dom";

interface HotListProps {
  items: MediaItem[];
}

export default function HotList({ items }: HotListProps) {
  return (
    <div className="rounded-lg border border-background-300 bg-background-100 overflow-hidden">
      <ul className="divide-y divide-background-200">
        {items.map((item, i) => (
          <li key={item.id}>
            <Link
              to={`/detail/${item.id}`}
              className="group flex items-center gap-3 p-3 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <span
                className={`w-7 h-7 flex items-center justify-center rounded-md text-sm font-bold font-label shrink-0 ${
                  i < 3
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-300 text-foreground-600"
                }`}
              >
                {i + 1}
              </span>
              <div className="w-12 h-16 rounded-md overflow-hidden bg-background-200 shrink-0">
                <img
                  src={item.poster}
                  alt={`${item.title} 海报`}
                  title={item.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h4 className="text-sm font-medium text-foreground-950 truncate group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h4>
                <p className="text-xs text-foreground-500 mt-1 truncate">
                  {typeLabel(item.type)} · {item.year} · {item.region}
                </p>
                <p className="text-xs text-accent-400 mt-1 flex items-center gap-1">
                  <i className="ri-fire-line"></i>
                  {formatViews(item.views)} 次浏览
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}